import { defineStore } from 'pinia';
import { copyPriorities, fetchSports, setSportPriority } from '@/api/admin-be';

export const useSportsStore = defineStore('sports', {
  state: () => ({
    records: null,
    loading: false,
    sports: [
      { value: 11205863, name: 'Баскетбол 3x3' },
      { value: 17, name: 'Американский футбол' },
      { value: 2, name: 'Австралийский футбол' },
      { value: 271554, name: 'Бадминтон' },
      { value: 3, name: 'Бейсбол' },
      { value: 4, name: 'Баскетбол' },
      { value: 7950337, name: 'Пляжный волейбол' },
      { value: 5, name: 'Бокс' },
      { value: 6, name: 'Крикет' },
      { value: 7, name: 'Велоспорт' },
      { value: 8, name: 'Дартc' },
      { value: 10915624, name: 'Киберспорт' },
      { value: 10, name: 'Футбол' },
      { value: 491393, name: 'Футзал' },
      { value: 6463040, name: 'Гэльский футбол' },
      { value: 12, name: 'Гольф' },
      { value: 99614, name: 'Гандбол' },
      { value: 208627, name: 'Хоккей на траве' },
      { value: 14, name: 'Конный спорт' },
      { value: 6463041, name: 'Хёрлинг' },
      { value: 15, name: 'Хоккей' },
      { value: 300115, name: 'Карате' },
      { value: 16, name: 'Мотоспорт' },
      { value: 73743, name: 'Рэгби Лига' },
      { value: 73744, name: 'Рэгби Юнион' },
      { value: 22, name: 'Снукер' },
      { value: 437727, name: 'Сквош' },
      { value: 269467, name: 'Настольный теннис' },
      { value: 24, name: 'Теннис' },
      { value: 91189, name: 'Воллейбол' },
    ].sort((a, b) => a.name > b.name ? 1 : -1),
  }),
  actions: {
    async fetchRecords(lang: string) {
      this.records = await fetchSports(lang);
    },
    async loadRecords(lang: string) {
      return fetchSports(lang);
    },
    async updatePriority(lang: string, sportId: number, order: number | null) {
      return setSportPriority(lang, sportId, order);
    },
    async copyPriorities(fromLang: string, toLang: string) {
      return copyPriorities(fromLang, toLang);
    },
  },
});
